import './icon.sass';

export { default } from './icon';
